import { render, staticRenderFns } from "./QuoteTotalDetails.vue?vue&type=template&id=5d7152fd&"
import script from "./QuoteTotalDetails.vue?vue&type=script&lang=js&"
export * from "./QuoteTotalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports